export default __webpack_public_path__ + "static/onairwithlove-9e4d346d931f876b19572c6211fb3994.png";